import React from 'react';
import { grey } from '@mui/material/colors';
import { Box, Stack, Typography } from '@mui/material';

import { Changes } from './Changes';

interface Props {
  changeType: string;
  changes: Record<string, Record<string, any>>;
}

export const QuoteChangesCell = ({ changeType, changes }: Props) => {
  return (
    <Box>
      {changeType === 'INITIAL_CREATION' ? (
        <Box
          sx={({ shadows }) => ({
            boxShadow: shadows[1],
            borderRadius: '0.2rem',
            padding: '0.2rem 0.4rem',
            border: `1px solid ${grey[300]}`,
          })}
        >
          <Typography>Quote created</Typography>
        </Box>
      ) : (
        <Stack direction="row" gap="0.5rem">
          {Object.entries(changes).map(([key, value]) => {
            const [changeKey] = key.split('.');
            return <Changes key={key} changeKey={changeKey} value={value} />;
          })}
        </Stack>
      )}
    </Box>
  );
};
